'use client';

import { useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { request } from '@isoapp/common/platform/networking/client/request';
import { graphql } from '#@graphql';
export function AccountDisconnect() {
  const [isConfirmingDisconnect, setIsConfirmingDisconnect] = useState(false);
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [disconnectError, setDisconnectError] = useState<string | null>(null);
  const queryClient = useQueryClient();
  async function handleDisconnect() {
    setIsDisconnecting(true);
    setDisconnectError(null);
    try {
      const sessionToken = typeof shopify === 'undefined' ? null : await shopify.idToken().catch(() => null);
      if (!sessionToken) {
        setDisconnectError('Could not retrieve session token. Please try again.');
        setIsDisconnecting(false);
        return;
      }
      const result = await request.auth(DisconnectShopify_Mutation, {
        input: {
          sessionToken
        }
      });
      if (result.disconnectShopify.__typename === 'DisconnectShopifySuccess') {
        if (typeof shopify !== 'undefined') {
          shopify.toast.show('Account disconnected from District');
        }
        await queryClient.invalidateQueries({
          queryKey: ['shopify', 'auth', 'me']
        });
        globalThis.location.reload();
      } else {
        const message = 'message' in result.disconnectShopify ? result.disconnectShopify.message : 'Disconnect failed';
        setDisconnectError(message ?? 'Disconnect failed');
        setIsDisconnecting(false);
        setIsConfirmingDisconnect(false);
      }
    } catch (error) {
      setDisconnectError(error instanceof Error ? error.message : 'Disconnect failed');
      setIsDisconnecting(false);
    }
  }
  return <>
      {!!disconnectError && <s-banner tone="critical" heading={disconnectError} dismissible onDismiss={() => {
      setDisconnectError(null);
    }} />}

      {isConfirmingDisconnect ? <s-stack gap="base">
          <s-banner tone="warning" heading="Disconnect from District?">
            This will remove the link between your Shopify store and District. Your existing products on District will
            not be deleted.
          </s-banner>
          <s-stack direction="inline" gap="base">
            <s-button variant="primary" onClick={handleDisconnect} loading={isDisconnecting} disabled={isDisconnecting}>
              Confirm Disconnect
            </s-button>
            <s-button variant="secondary" onClick={() => {
          setIsConfirmingDisconnect(false);
        }} disabled={isDisconnecting}>
              Cancel
            </s-button>
          </s-stack>
        </s-stack> : <s-button variant="secondary" onClick={() => {
      setIsConfirmingDisconnect(true);
    }}>
          Disconnect from District
        </s-button>}
    </>;
}
const DisconnectShopify_Mutation = graphql(`
  mutation DisconnectShopify($input: DisconnectShopifyInput!) {
    disconnectShopify(input: $input) {
      __typename
      ... on DisconnectShopifySuccess {
        noop
      }
      ... on UserInputError {
        message
      }
      ... on InternalError {
        message
      }
    }
  }
`);